// imports
import React from 'react';
import { ConnectKitButton } from 'connectkit';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants';
import { logAnalytics } from '../../services/firebase';

// interfaces / types / consts
interface Props { outlined?: boolean; navigates?: boolean }

interface ConnectProps {
  title: string;
  outlined: boolean;
  onClick: () => void;
}

// private components
function Connect(props: ConnectProps): React.ReactElement {
  const { title, outlined, onClick } = props;
  return (
    <button type="button" className={outlined ? 'connect-button-outline' : 'connect-button'} onClick={onClick}>
      <span>{title}</span>
    </button>
  );
}

// exports
export default function ConnectButton(props: Props): JSX.Element {
  const { navigates, outlined } = props;
  // hooks configuration
  const navigate = useNavigate();
  // private methods
  const connect = (isConnected: boolean, show?: () => void): void => {
    if (isConnected && navigates) {
      logAnalytics({ action: 'CLICK', name: 'PLAY_GAME' });
      navigate(ROUTES.GAME);
    } else {
      logAnalytics({ action: 'CLICK', name: 'CONNECT_WALLET' });
      show!();
    }
  };
  // render
  return (
    <ConnectKitButton.Custom>
      {({ isConnected, truncatedAddress, show }) => {
        // eslint-disable-next-line no-nested-ternary
        const title = !isConnected ? 'Connect Wallet' : (navigates ? 'Play Game' : truncatedAddress!);
        return <Connect title={title} outlined={Boolean(outlined)} onClick={() => { connect(isConnected, show); }} />;
      }}
    </ConnectKitButton.Custom>
  );
}

// default props
ConnectButton.defaultProps = { outlined: false, navigates: false };
